export default "__VITE_ASSET__J6pUKkQK__"